module.exports = __webpack_public_path__ + "static/bg-header-health-and-fitness-01819dcd848d9e754ccfe2a387979eb4.svg";